if(!customElements.get('pagination-button')){
    class ProductListPaginationButton extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnLoadMore = this.querySelector('.btn-load-more');

            if(this.closest('custom-search-product-list')){

                this.productList = this.closest('custom-search-product-list');
                this.productsWrapper = this.productList.querySelector('#search-item-list__items-wrapper');
                this.products = this.productList.querySelector('#search-item-list__items');
                this.content = 'search';

            }else if(this.closest('custom-collection-product-list')){

                this.productList = this.closest('custom-collection-product-list');
                this.productsWrapper = this.productList.querySelector('#collection-product-list__products-wrapper');
                this.products = this.productList.querySelector('#collection-product-list__products');
                this.content = 'collection';

            }
            
            this.btnColumnSwitch = this.productList.querySelector('.product-view-switch-wrapper');

            this.btnLoadMore.addEventListener('click', e => {
                e.preventDefault();

                this.btnLoadMore.setAttribute('data-disabled', 'true');
                this.loadMoreProducts();
            });

            this.btnLoadMore.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    e.preventDefault();

                    this.btnLoadMore.setAttribute('data-disabled', 'true');
                    this.loadMoreProducts();
                }
            })

            this.autoFill();
        }

        // 在庫が少ない商品の非表示で1ページあたりの表示数が少なくなるため、一定数に達するまで続きを自動で読み込む
        async autoFill(){
            if(this.content !== 'collection') return;
            const minItems = 24;
            let guard = 0;
            while(
                guard++ < 15 &&
                !this.btnLoadMore.classList.contains('d-none') &&
                this.btnLoadMore.dataset.url &&
                this.products.querySelectorAll('.product-card__wrapper').length < minItems
            ){
                this.btnLoadMore.setAttribute('data-disabled', 'true');
                await this.loadMoreProducts(true);
            }
        }

        async loadMoreProducts(silent = false){
            try{
                const nextPageRes = await fetch(
                    `${this.btnLoadMore.dataset.url}`
                );
                const nextPageText = await nextPageRes.text();
                const nextPageHTML = new DOMParser().parseFromString(nextPageText, 'text/html');

                const productsWrapper = this.content == 'collection'? 
                    nextPageHTML.querySelector('#collection-product-list__products-wrapper'):
                    nextPageHTML.querySelector('#search-item-list__items-wrapper');

                const products = this.content == 'collection'? 
                    productsWrapper.querySelector('#collection-product-list__products'):
                    productsWrapper.querySelector('#search-item-list__items');

                const btnLoadMore = productsWrapper.querySelector('.btn-load-more');

                // get product 
                const productCards = products.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper');
                
                productCards.forEach(item => {
                    item.classList.remove('col-xl-2', 'col-xl-3', 'col-xl-4', 'col-6', 'col-12');

                    if(this.btnColumnSwitch.dataset.column == '3'){
                        item.classList.add('col-xl-4', 'col-12');
                    }else if(this.btnColumnSwitch.dataset.column == '6'){
                        item.classList.add('col-xl-2', 'col-6');
                    }else{
                        item.classList.add('col-xl-3', 'col-6');
                    }

                    this.products.appendChild(item);
                });

                if (productCards.length > 0 && !silent) {
                    setTimeout(() => {
                        if(productCards[0].querySelectorAll('.tab-able-item').length > 0){
                            productCards[0].querySelectorAll('.tab-able-item')[0].focus();
                        }
                    }, 100);
                }

                if(btnLoadMore){
                    this.btnLoadMore.classList.remove('d-none');
                    this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                }else{
                    this.btnLoadMore.classList.add('d-none');
                }

                // add swatch checked
                const variantSwatchSelector = this.products.querySelectorAll('variant-swatch-selector');
                if(variantSwatchSelector.length > 0){
                    variantSwatchSelector.forEach(item => {
                        item.loadCheckedRadioInput();
                    });
                }
            } catch (error){

                console.error(error);
                alert(error.message);

            } finally {
                this.btnLoadMore.setAttribute('data-disabled', 'false');
            }
        }
    }

    customElements.define('pagination-button', ProductListPaginationButton);
}
